import type { MedicationPadItemType } from '@/components/Patient/components/PrescriptionPad';
import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType } from '../types';

export const updateMedicationPadItems: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (medicationPadItems: MedicationPadItemType[]) => void
> = (set) => (medicationPadItems) => {
  set(
    (state) => {
      state.prescriptionAssistant.prescriptionPad.medicationPadItems = medicationPadItems;
    },
    false,
    'prescriptionPad/updateMedicationPadItems',
  );
};
